import React from 'react';
import { Mail } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Mail",
    title: "Email Professionnel",
    description: "Votre adresse @votredomaine.fr"
  },
  {
    iconName: "HardDrive",
    title: "Stockage 50 Go",
    description: "Espace de stockage généreux"
  },
  {
    iconName: "Shield",
    title: "Protection Avancée",
    description: "Anti-spam et anti-virus inclus"
  },
  {
    iconName: "Smartphone",
    title: "Multi-Appareils",
    description: "Synchronisation complète"
  },
  {
    iconName: "Calendar",
    title: "Agenda Intégré",
    description: "Calendrier collaboratif"
  },
  {
    iconName: "Users",
    title: "Contacts",
    description: "Gestion des contacts avancée"
  }
];

const steps = [
  {
    title: "Inscrivez-vous sur FRANCE STUDENT",
    description: "Créez votre compte étudiant en quelques clics"
  },
  {
    title: "Vérifiez votre statut étudiant",
    description: "Téléchargez votre carte étudiante ou certificat de scolarité"
  },
  {
    title: "Activez votre messagerie",
    description: "Recevez vos identifiants par email sous 24h"
  }
];

const MailPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.francestudent.org/store/messagerie';
  };
  return (
    <div>
      <ServiceHeader
        title="Messagerie Professionnelle"
        description="Une solution de messagerie complète et sécurisée pour vos communications professionnelles."
        icon={<Mail className="w-8 h-8 text-white" />}
        color={colors.primary}
        imageUrl="https://images.unsplash.com/photo-1557200134-90327ee9fafa?auto=format&fit=crop&q=80"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Caractéristiques */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.primary}
            />
          ))}
        </div>

        {/* Fonctionnalités détaillées */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Fonctionnalités Incluses</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Email Professionnel</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Adresse email personnalisée</li>
                  <li>• Protocoles IMAP/POP3/SMTP</li>
                  <li>• Webmail responsive</li>
                  <li>• Signatures personnalisées</li>
                  <li>• Réponses automatiques</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Sécurité et Protection</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Anti-spam avancé</li>
                  <li>• Anti-virus intégré</li>
                  <li>• Chiffrement SSL/TLS</li>
                  <li>• Sauvegardes quotidiennes</li>
                  <li>• Protection contre le phishing</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div class="pt-11">
          <ServiceSteps
                title="Comment en Bénéficier"
                steps={steps}
                color={colors.primary}
                ctaText="Activer ma messagerie"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default MailPage;